import React from "react";

const SelectedBoxTypesBar = ({ boxTypeOverview }) => {
  return (
    <div
      className="divRow"
      style={{
        width: "100%",
        justifyContent: "center",
        marginTop: "5px",
      }}
    >
      <div className="textBold">Selected BoxTypes:</div>
      <div
        className="divRow"
        style={{
          justifyContent: "center",
          width: "350px",
          backgroundColor: "white",
          border: "2px solid grey",
          borderRadius: "10px",
          marginLeft: "15px",
        }}
      >
        {boxTypeOverview.map((bt, index) => (
          <div
            key={index}
            className="textBold"
            style={{ marginLeft: "5px", marginRight: "5px" }}
          >
            {bt.names.plural}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SelectedBoxTypesBar;
